<template>
<v-card outlined>
    <v-card-text class="d-flex pa-0">
        <div class="d-flex justify-space-between flex-wrap align-center pa-3 flex-grow-1">
            <div v-if="fetching">
                CARGANDO...
            </div>
            <div class="text-h6" v-else>
                {{ count }} USUARIOS
            </div>
            <div>
                <UserModal @saved="fetch()">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" :disabled="fetching" small><v-icon small>mdi-plus</v-icon>NUEVO USUARIO</v-btn>
                    </template>
                </UserModal>
            </div>
        </div>
        <v-divider vertical/>
        <div class="pa-3">
            <v-btn icon :loading="fetching" @click="fetch"><v-icon>mdi-reload</v-icon></v-btn>
        </div>
    </v-card-text>
    <v-divider/>
    <v-card-text>
        <template v-if="fetching">
            <v-card outlined class="pa-4 text-center">
                CARGANDO...
            </v-card>
        </template>
        <template v-else>
            <v-card v-if="!list.length" outlined class="pa-4 text-center">
                SIN USUARIOS
            </v-card>
            <template v-else>
                <div v-for="(user, index) in list" :key="`${index}-user-${user.id}-juego-set`">
                    <User
                        :user="user"
                        :class="{'mt-10': index > 0}"
                        @saved="fetch"
                        />
                    <v-divider class="mt-10" inset/>
                </div>
            </template>
        </template>
    </v-card-text>
</v-card>
</template>
<script>

import UserService from '@/services/operadora/institution/UserService';

import User from './user.vue';

import UserModal from '@components/entities/institution/user/modal.vue';

export default {
    components: {
        User,
        UserModal
    },
    data: function () {
        return {
            fetching: false,
            list: [],
            count: 0,
        };
    },
    computed: {

    },
    methods: {
        fetch: async function () {
            this.fetching = true;

            this.count = 0;
            this.list = [];

            try {
                const {
                    list
                } = await UserService.getListWithJuegoSet();
    
                this.count = list.length;
                this.list = list;
            } catch (error) {
                // TEST
            }

            this.fetching = false;
        }
    },
    mounted: function () {
        this.fetch();
    }
}
</script>
